
import Images from '../../state/stores/Image/images';
import SecondaryButton from '../Button/SecondaryButton';
import { Image, View } from 'react-native';
import { ParagraphMRegular } from '../../config/designSystem/typography';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useBreakpoint } from '../../hooks/useBreakpoint';

interface SectionItemProps {
  onPress: () => void;
  text: string;
  buttonText: string;
  backgroundColor?: string;
  textColor?: string;
}
export const HelpDeskSectionItem = ({
  onPress,
  text,
  buttonText,
  backgroundColor,
  textColor,
}: SectionItemProps) => {
  const borderRadius = 12;
  const WIDTH_IMAGE = 48;
  const HEIGHT_IMAGE = 48;
  const {width} = useAvailableDimensions();
  const isSmall = useBreakpoint().sm;
  return (

    <View
      style={[{
        borderRadius,
        backgroundColor,
        padding: 22,
        flex:1,
      }, !isSmall ? {
        maxWidth: 0.35 * width
      } : {

      }]}
    >
      <View style={{flexDirection: 'row', alignItems: 'center', gap: 16}}>
        <View style={[{
          width: WIDTH_IMAGE,
          height: HEIGHT_IMAGE,
          borderRadius
        }]}>
          <Image
            source={Images['logo']['multicolor']}
            width={WIDTH_IMAGE}
            height={HEIGHT_IMAGE}
            resizeMode='contain'
            style={{
              borderRadius,
              width: '100%',
              height: '100%'}}
          />
        </View>
        <ParagraphMRegular
          color={textColor}
          style={{flexShrink: 1}}
        >
          {text}
        </ParagraphMRegular>
      </View>
      <View style={{alignItems:'center', width: '100%'}}>
        <SecondaryButton
          onPress={onPress}
          label={buttonText || 'Contact us'}
          marginHorizontal={0}
          paddingHorizontal={16}
          paddingVertical={8}
          height={40}
        />
      </View>

    </View>
  );
};
